// extracted by mini-css-extract-plugin
export default {"header":"WarehouseTable_header__EO4fQ","price":"WarehouseTable_price__FUFiZ"};